import { render } from "./UserTypeDataTable.vue?vue&type=template&id=bb5de464"
import script from "./UserTypeDataTable.vue?vue&type=script&lang=js"
export * from "./UserTypeDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__